import React, { useEffect, useState, useMemo } from 'react';
import SelectInput from '../../../../common/components/SelectInput';
import { useRequestsContext } from '../../../../common/hooks/requestHook';
import { addProductToOrder } from '../../../../API/repositories/order';
import { useTranslationContext } from '@/common/hooks/useTranslationContext';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import ActionButton from '@/common/components/buttons/ActionButton';
import Icon from '@/common/components/Icon';

const ChooseProductView = ({
	product,
	currency,
	setChosenProductData,
	chosenProductData,
	orderId,
	contact,
	additionalInfo,
}) => {
	const [selectedOption, setSelectedOption] = useState(null);
	const [selectedOptionPrice, setSelectedOptionPrice] = useState(null);
	const { makeRequest } = useRequestsContext();
	const { addMessage } = useMessageQueueContext();
	const { translation } = useTranslationContext();
	const additionalInfoParsed = useMemo(() => {
		if (!additionalInfo) {
			return null;
		}

		try {
			return JSON.parse(additionalInfo);
		} catch (e) {
			return null;
		}
	}, [additionalInfo]);

	const hadnleAddProduct = async (e) => {
		e.preventDefault();

		const payload = [
			...chosenProductData,
			{
				_id: chosenProductData.length + 1,
				name: selectedOption.label,
				value: selectedOption.value,
				price: selectedOptionPrice.value,
			},
		];

		const response = await makeRequest(
			addProductToOrder.bind(null, orderId, payload),
		);
		if (response?.data && selectedOption && selectedOptionPrice) {
			setChosenProductData((prev) => payload);
		} else {
			return addMessage(
				'You are not allowed to update this order, please, quickly contact CC Manager',
				'error',
			);
		}
	};

	const hadnleDelteProductItem = async (_id) => {
		let data = chosenProductData.filter((item) => item._id !== _id);

		const response = await makeRequest(
			addProductToOrder.bind(null, orderId, data),
		);

		if (response?.data) {
			let id = 1;
			data = data.map((data) => {
				data._id = id;
				id++;
				return data;
			});
			setChosenProductData(data);
		} else {
			return addMessage(
				'You are not allowed to update this order, please, quickly contact CC Manager',
				'error',
			);
		}
	};

	useEffect(() => {}, [chosenProductData]);
	return (
		<div>
			<h4>
				<u>{translation.chooseOrderItem}:</u>
			</h4>
			<div
				style={{
					display: 'flex',
					width: '100%',
					justifyContent: 'center',
					gap: '20px',
					alignItems: 'center',
					marginTop: '20px',
				}}
			>
				<label style={{ fontSize: '20px' }}>
					<strong style={{ marginRight: '20px' }}>{translation.name}:</strong>{' '}
					{product.name}
				</label>
				<SelectInput
					name={translation.variants}
					width={80}
					selected={selectedOption}
					setSelected={setSelectedOption}
					options={product.variants.map((varaint) => {
						return { label: varaint.name, value: varaint.short };
					})}
					selectWidth={140}
				/>
				<SelectInput
					name={translation.price}
					width={40}
					selected={selectedOptionPrice}
					setSelected={setSelectedOptionPrice}
					options={product.prices.map((price) => {
						return { label: price.value, value: price.value };
					})}
					selectWidth={140}
				/>
				<div style={{ display: 'flex', justifyContent: 'right' }}>
					<ActionButton
						onClick={(e) => hadnleAddProduct(e)}
						disabled={
							contact.country === 'cz' && undefined === contact.hasPromotion
						}
						text={translation.add}
					/>
				</div>
			</div>
			<h6 style={{ marginLeft: '80px', marginTop: '20px' }}>
				{translation.chosenOrderItems}:
			</h6>

			{chosenProductData.length > 0 ? (
				<div
					style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
				>
					<table>
						<thead>
							<tr>
								<th style={{ fontSize: '20px', textAlign: 'center' }}>
									{translation.variant}
								</th>
								<th style={{ fontSize: '20px', textAlign: 'center' }}>
									{translation.short}
								</th>
								<th style={{ fontSize: '20px', textAlign: 'center' }}>
									{translation.price}
								</th>
								<th style={{ fontSize: '20px', textAlign: 'center' }}></th>
							</tr>
						</thead>
						<tbody>
							{chosenProductData.map((data) => (
								<tr style={{}}>
									<td
										style={{
											width: '100px',
											fontSize: '18px',
											borderTop: '1px solid grey',
											textAlign: 'center',
											padding: '11px 0px',
										}}
									>
										{data.name}
									</td>
									<td
										style={{
											width: '200px',
											fontSize: '18px',
											borderTop: '1px solid grey',
											textAlign: 'center',
										}}
									>
										{data.value}
									</td>
									<td
										style={{
											width: '200px',
											fontSize: '18px',
											borderTop: '1px solid grey',
											textAlign: 'center',
										}}
									>
										{data.price} {currency}
									</td>
									<td
										style={{
											width: '80px',
											fontSize: '18px',
											borderTop: '1px solid grey',
											textAlign: 'center',
										}}
									>
										<ActionButton
											onClick={() => hadnleDelteProductItem(data._id)}
											style={{ background: 'none', border: 'none' }}
										>
											<Icon
												name='remove'
												style={{ color: 'red', fontSize: '20px' }}
											/>
										</ActionButton>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
			) : (
				<div>{translation.nothingToSee}</div>
			)}
			{additionalInfoParsed && (
				<div style={{ marginTop: 20, paddingLeft: 20 }}>
					<h5>{translation.additionalInfo}</h5>
					<div
						style={{
							display: 'flex',
							flexDirection: 'column',
							fontSize: 14,
							gap: 4,
							paddingLeft: 8,
							marginTop: 12,
						}}
					>
						{Object.keys(additionalInfoParsed).map((key) => {
							return (
								<div>
									<span style={{ fontWeight: 600 }}>{key}</span>:{' '}
									{additionalInfoParsed[key]}
								</div>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);
};

export default ChooseProductView;
